<template>
    <div id="search-container" class="c-search-page">

        <SearchForm/>
        <div v-if="urlParams" class="c-search-page__tabs">
            <button @click="setArea('')" :class="{ active: area === '' }">All</button>
            <button @click="setArea('works')" :class="{ active: area === 'works' }">Shakespeare's Works</button>
            <button @click="setArea('blogs')" :class="{ active: area === 'blogs' }">Blogs &amp; Podcasts</button>
            <button @click="setArea('events')" :class="{ active: area === 'events' }">Events</button>
            <button @click="setArea('teach')" :class="{ active: area === 'teach' }">Teaching Resources</button>
        </div>
        <Statistics :area="area" />

        <section class="c-search-page__panes">
            <div class="c-search-page__panes-wrap">
                <Tips v-if="area === 'works'" />
                <Filters :area="area" />
            </div>
            <section class="c-search-page__results">
                <Results :area="area" />
            </section>
        </section>

    </div>

</template>

<script>
    import {EventBus} from "./event-bus"
    import Filters from "./components/Filters"
    import Tips from "./components/Tips"
    import Results from "./components/Results"
    import SearchForm from "./components/SearchForm"
    import Statistics from "./components/Statistics"
    import 'url-search-params-polyfill'

    export default {
        name: "SearchApp",
        components: {
            Filters,
            Tips,
            Results,
            SearchForm,
            Statistics,
        },
        data() {
            return {
                urlParams: {},
                query: '',
                area: ''
            }
        },
        mounted() {
            EventBus.$on('update-url-params', this.updateUrlParams)
            this.gatherUrlParams()
            this.area = this.urlParams.area ? this.urlParams.area : ''
        },
        methods: {
            setArea(area) {
                this.area = area
                this.urlParams.area = area
                this.clearFilters()
            },
            clearFilters() {
                EventBus.$emit('clear-filters')
                this.stripTaxonomyFilters()
                this.pushParamsToUrl()
            },
            gatherUrlParams() {
                const urlSearchParams = new URLSearchParams(window.location.search)

                urlSearchParams.forEach((value, key) => {
                    this.urlParamsHelper(key, value, true)
                })
                EventBus.$emit('url-params-updated', this.urlParams)

                this.$nextTick(() => EventBus.$emit('update-results', this.urlParams))
            },
            /**
             * Strip any filters from the this.urlParams so ony `q` and `area` are left
             */
            stripTaxonomyFilters() {
                let data = {};
                for (const [key, value] of Object.entries(this.urlParams)) {
                    if (key === 'q' || key === 'area') {
                        data[key] = value
                    }
                }
                this.urlParams = data
            },
            paramExists(array, value) {
                if (Array.isArray(array)) {
                    return array.some((element) => element === value)
                }
                return false
            },
            /**
             * Take this.urlParams and set current URL to query string
             */
            pushParamsToUrl() {
                const keys = Object.keys(this.urlParams)
                let flatParams = []

                for (const key of keys) {
                    if (Array.isArray(this.urlParams[key])) {
                        this.urlParams[key].forEach(value => {
                            if (!flatParams.some(element => element === value)) {
                                let object = {}
                                object[key] = value
                                flatParams.push(object)
                            }
                        })
                    } else {
                        let object = {}
                        object[key] = this.urlParams[key]
                        flatParams.push(object)
                    }
                }
                
                window.history.replaceState(null, null, this.queryStringBuilder(flatParams) ? '?' + this.queryStringBuilder(flatParams) : '/search/')

                EventBus.$emit('update-results', this.urlParams)
            },
            /**
             * Filter params into URL string format
             */
            queryStringBuilder(params) {
                let urlParams = params.filter(param => {
                    for (const key in param) {
                        return param[key] && param[key].length > 0
                    }
                })

                return urlParams.map(object => {
                    for (const [key, value] of Object.entries(object)) {
                        return key + '=' + value
                    }
                }).join('&')
            },
            /**
             * Set this.urlParams with support for nested values
             */
            urlParamsHelper(key, value, state) {
                // Filter out any unwanted query params such as Google Analytics
                if (key.charAt(0) === '_') {
                    return;
                }
                if (state) {
                    if (key === 'area') {
                        this.area = value
                        this.urlParams['area'] = value
                    } else  if (key === 'q') {
                        this.query = value
                        this.urlParams['q'] = value
                    } else if (!this.urlParams[key]) {
                        this.urlParams[key] = value
                    } else if (this.urlParams[key] && this.urlParams[key] !== value && !Array.isArray(this.urlParams[key])) {

                        let temp = []
                        temp.push(this.urlParams[key])
                        temp.push(value)
                        this.urlParams[key] = temp

                    } else if (this.urlParams[key] && Array.isArray(this.urlParams[key]) && !this.paramExists(this.urlParams[key], value)) {

                        this.urlParams[key].push(value)

                    } else if (this.urlParams[key] !== value) {
                        this.urlParams[key] = value
                    }
                } else {
                    if (this.urlParams[key] && (this.urlParams[key] === value || key === 'q' || key === 'area')) {
                        delete (this.urlParams[key])
                    } else if (Array.isArray(this.urlParams[key]) && this.paramExists(this.urlParams[key], value)) {
                        this.urlParams[key] = this.urlParams[key].filter(element => {
                            return !(element === value)
                        })
                    }
                }
            },
            /**
             * Set URL params before passing to URL
             */
            updateUrlParams(params) {
                if (Array.isArray(params)) {
                    params.forEach(element => {
                        this.urlParamsHelper(element.name, element.value, element.state)
                    })
                } else {
                    this.urlParamsHelper(params.name, params.value, params.state)
                }

                this.pushParamsToUrl()
            }
        }
    }
</script>

<style scoped>

</style>
